// Shared constants for the tournament-games dialog family (iter279).
// Re-imported from TournamentGames.js as well so the source of truth
// stays in one place.

export const GAME_CATEGORIES = [
  { value: 'practice', label: 'Practice' },
  { value: 'league', label: 'League' },
  { value: 'competitive', label: 'Competitive' },
  { value: 'quarter_final', label: 'Quarter Final' },
  { value: 'semi_final', label: 'Semi Final' },
  { value: 'final', label: 'Final' },
  { value: 'recreational', label: 'Recreational' },
];

export const GAME_CATEGORY_COLORS = {
  practice: 'bg-slate-100 text-slate-700',
  league: 'bg-blue-100 text-blue-700',
  competitive: 'bg-purple-100 text-purple-700',
  quarter_final: 'bg-amber-100 text-amber-700',
  semi_final: 'bg-orange-100 text-orange-700',
  final: 'bg-red-100 text-red-700',
  recreational: 'bg-green-100 text-green-700',
};
